const form = document.getElementById('ContactForm');

if (form && form.querySelector('input[type="tel"]') && form.querySelector('select#request-type')) {
  document.getElementById('request-type').addEventListener('change', function () {
    var selectedOption = this.options[this.selectedIndex];
    var countryCode = selectedOption.getAttribute('data-countrycode');
    var phoneInput = document.getElementById('ContactForm-phone');

    // Regular expression to detect if the phone field already has a country code
    var countryCodePattern = /^\+\d+\s*/;

    // Remove the existing prefix if it matches a country code
    phoneInput.value = phoneInput.value.replace(countryCodePattern, '');

    // If the field is empty, or doesn't have a prefix, add the selected country code
    if (phoneInput.value === '') {
      phoneInput.value = countryCode + ' ';
    } else {
      phoneInput.value = countryCode + ' ' + phoneInput.value;
    }
  });
}
